var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMontenegro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13761_68368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00256348H0V15.9949H24V-0.00256348Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.605 1.39246H1.39502V14.6H22.605V1.39246Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2603 5.91496H13.7403V4.51996L13.0428 4.87246L12.0003 3.82996L10.9578 4.87246L10.2603 4.51996V5.91496Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1276 8.00001H13.3951C13.4641 7.87737 13.5001 7.73885 13.4993 7.59809C13.4986 7.45733 13.4611 7.31921 13.3907 7.19732C13.3203 7.07543 13.2194 6.974 13.0978 6.90302C12.9763 6.83203 12.8383 6.79395 12.6976 6.79251C12.5503 6.79667 12.4071 6.84165 12.284 6.92244C12.1608 7.00322 12.0625 7.11663 12.0001 7.25001C11.9601 7.14271 11.8977 7.04519 11.817 6.96401C11.7362 6.88283 11.639 6.81987 11.532 6.77935C11.4249 6.73883 11.3103 6.7217 11.1961 6.72909C11.0818 6.73649 10.9705 6.76826 10.8695 6.82225C10.7686 6.87624 10.6803 6.95121 10.6107 7.04213C10.5411 7.13304 10.4918 7.2378 10.466 7.34936C10.4403 7.46092 10.4387 7.5767 10.4614 7.68892C10.4841 7.80115 10.5305 7.90722 10.5976 8.00001H8.87256C8.87846 8.25797 8.9856 8.50326 9.17084 8.68288C9.35608 8.86251 9.60454 8.96205 9.86256 8.96002C9.85759 9.16144 9.91662 9.35926 10.0312 9.52502C10.1457 9.69078 10.3099 9.81594 10.5001 9.88251L9.75006 10.6325L10.5001 11.3825L11.5501 10.3325L11.6701 10.37L11.0401 11.8025C11.6712 12.0523 12.3739 12.0523 13.0051 11.8025L12.3751 10.37L12.5026 10.3325L13.5001 11.405L14.2501 10.655L13.5001 9.90502C13.7 9.84769 13.8757 9.72648 14.0003 9.5599C14.1249 9.39332 14.1916 9.19053 14.1901 8.98251C14.4428 8.97093 14.6812 8.86232 14.8559 8.67931C15.0305 8.49629 15.1278 8.25298 15.1276 8.00001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.52496L10.8677 9.04246V10.085L12.0002 10.7825L13.1327 10.085V9.04246L12.0002 8.52496Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1252 8H10.8677V9.395H13.1252V8Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13761_68368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontenegro);
export default __webpack_public_path__ + "static/media/Montenegro.9d6d9d334176d7990462f2bd7d753112.svg";
export { ForwardRef as ReactComponent };